export default class RouteName {
  static get Settings () { return 'settings' }
  static get Directory () { return 'directory' }
  static get Organizations () { return 'organizationsList' }
  static get Regions () { return 'regionsList' }
  static get Branches () { return 'filialsList' }
  static get DeliveryZones () { return 'deliveryZones' }
  static get Staff () { return 'user-list' }
  static get Menu () { return 'Меню' }
  static get PriceLists () { return 'price-lists' }
  static get Categories () { return 'categoriesList' }
  static get TechnicalCards () { return 'Технические карты' }
  static get Modifications () { return 'Модификаторы' }
  static get Promocodes () { return 'Промокоды' }
  static get Collections () { return 'Коллекции' }
  static get News () { return 'Новости' }
  static get Slider () { return 'Главный слайдер' }
  static get Promotions () { return 'Акции' }
  static get SettingsKkmServer () { return 'settings.kkm-server' }
  static get SettingsPaymentMethods () { return 'settings.payment-methods' }
  static get SettingsPrintingFiscal () { return 'settings.printing-fiscal' }
  static get SettingsQrFeedback () { return 'settings.qr-feedback' }
  static get SettingsReviewActions () { return 'settings.review-actions' }
  static get SettingsOrders () { return 'settings.orders' }
  static get SeoPageMetaList () { return 'seoPageMetaList' }
  static get RevenueDynamicsStat () { return 'revenueDynamicsStat' }
  static get CashSourcesStat () { return 'cashSourcesStat' }
  static get WorkSchedulesStat () { return 'Статистика рабочего времени' }
  static get MenuAbcStat () { return 'menuAbcStat' }
  static get AggregatorsAbcStat () { return 'aggregatorsAbcStat' }
  static get AggregatorsRevenueDynamicsStat () { return 'aggregatorsRevenueDynamicsStat' }
  static get ConnectorsAbcStat () { return 'connectorsAbcStat' }
  static get ConnectorsRevenueDynamicsStat () { return 'connectorsRevenueDynamicsStat' }
  static get ClientsStat () { return 'clientsStat' }
  static get ClientsSegmentationStat () { return 'clientsSegmentationStat' }
  static get RatingStat () { return 'ratingStat' }
  static get CourierStat () { return 'courierStat' }
  static get CallCenterOrdersStat () { return 'callCenterOrdersStat' }
  static get CallCenterFilialsStat () { return 'callCenterFilialsStat' }
  static get CallCenterEmployeesStat () { return 'callCenterEmployeesStat' }
  static get CallCenterEmployeesWorkScheduleStat () { return 'callCenterEmployeesWorkScheduleStat' }
  static get LoginStat () { return 'loginStat' }
  static get Connectors () { return 'connectors' }
  static get Sources () { return 'sources' }
  static get LegalInfoPages () { return 'legalInfoPagesList' }
  static get LegalInfoPageCreate () { return 'legalInfoPageCreate' }
  static get LegalInfoPageEdit () { return 'legalInfoPageEdit' }

  static get KnowledgeBase () { return 'knowledgeBase' }
  static get KnowledgeBaseDownloads () { return 'knowledgeBaseDownloads' }
  static get KnowledgeBaseFilialConnection () { return 'knowledgeBaseFilialConnection' }

  static get BillingMyTariff () { return 'billing-my-tariff' }
  static get BillingWriteOffs () { return 'billing-write-offs' }
  static get BillingPaymentsHistory () { return 'billing-payments-history' }
  static get BillingPaymentMethods () { return 'billing-payment-methods' }
  static get BillingTopup () { return 'billing-topup' }
  static get BillingTopupResult () { return 'billing-topup-result' }

  static get Administration () { return 'administration' }
  static get AdministrationPaymentAccounts () { return 'administration.payment-accounts' }
  static get AdministrationPaymentAccountCard () { return 'administration.payment-account-card' }
  static get AdministrationFaktLegalEntities () { return 'administration.fakt-legal-entities' }
  static get AdministrationFaktLegalEntityCreate () { return 'administration.fakt-legal-entity-create' }
  static get AdministrationFaktLegalEntityEdit () { return 'administration.fakt-legal-entity-edit' }
  static get AdministrationTariffs () { return 'administration.tariffs' }
  static get AdministrationTariffCreate () { return 'administration.tariff-create' }
  static get AdministrationTariffEdit () { return 'administration.tariff-edit' }
  static get AdministrationFilialConnection () { return 'administration.filial-connection' }
  static get AdministrationFilialConnectionCard () { return 'administration.filial-connection-card' }
  // FAKT Support: «Обращения филиала» и тикет филиала (T09)
  static get SupportAppeals () { return 'support-appeals' }
  static get SupportAppeal () { return 'support-appeal' }
}
